import { render, staticRenderFns } from "./InvestmentCompleted.vue?vue&type=template&id=72996d2f&"
import script from "./InvestmentCompleted.vue?vue&type=script&lang=ts&"
export * from "./InvestmentCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports